const translation = {
  // Navbar
  nav_home: 'Home',
  nav_services: 'Services',
  nav_about: 'About Us',
  nav_reviews: 'Reviews',
  nav_quote: 'Free Quote',

  // Hero
  hero_badge: 'Professional & Guaranteed Cleaning',
  hero_title1: 'Your Home Deserves',
  hero_title2: 'To Always Shine',
  hero_desc: 'Residential cleaning, pressure washing, windows, move-out cleaning and more. Impeccable service in The Villages, FL and surrounding areas.',
  hero_cta1: 'Free Quote',
  hero_cta2: 'View Services',
  hero_stat1: 'Satisfaction Guaranteed',
  hero_stat2: '24h Response',
  hero_stat3: 'Free Quote',

  // Services Preview
  sp_eyebrow: 'What We Do',
  sp_heading: 'Our Services',
  sp_sub: 'We offer professional cleaning solutions for all types of residential properties and condominium communities.',
  sp_details: 'View details',
  sp_all: 'View All Services',

  // About Preview
  ap_eyebrow: 'Who We Are',
  ap_heading: 'Professional Cleaning with',
  ap_heading_accent: 'Heart & Soul',
  ap_heading_end: 'in Every Detail',
  ap_p1: 'We are a family business dedicated to transforming spaces with high-quality cleaning. From move-out cleaning to valet trash services for condominiums, our trained team guarantees exceptional results in every job.',
  ap_p2: 'We use top-quality cleaning products and proven techniques to ensure every corner is spotless. Your home or property deserves the best care.',
  ap_clients: '100% Guaranteed',
  ap_area: 'Your satisfaction, our priority',
  ap_exp: 'Years of Experience',
  ap_val1_t: 'Trust',
  ap_val1_d: 'Verified and trustworthy staff on every visit.',
  ap_val2_t: 'Quality',
  ap_val2_d: 'Premium products and professional techniques.',
  ap_val3_t: 'Punctuality',
  ap_val3_d: 'We arrive when we promise, always.',
  ap_val4_t: 'Commitment',
  ap_val4_d: 'Your satisfaction is our guarantee.',
  ap_cta: 'Learn More About Us',

  // Testimonials / Guarantees section
  rev_eyebrow: 'Our Promise',
  rev_heading: 'Committed to Your Satisfaction',
  rev_sub: 'We start with the commitment to do every job perfectly from day one.',
  rev_all: 'View all reviews',

  // Guarantee cards
  guar_t1: '100% Satisfaction Guaranteed',
  guar_d1: "If you're not completely satisfied, we come back to fix it at no extra cost.",
  guar_t2: 'Verified Staff',
  guar_d2: 'Every team member goes through background checks and professional training.',
  guar_t3: 'Eco-Friendly Products',
  guar_d3: 'We only use products that are safe for your family, pets, and the environment.',
  guar_t4: 'Punctuality Guaranteed',
  guar_d4: "We arrive at the agreed time or notify you in advance. Your time matters.",
  guar_first_h: 'Be Our First Client!',
  guar_first_d: "We're beginning to write our story and we want you to be part of it. Get impeccable service with a total satisfaction guarantee from day one.",
  guar_first_btn: 'Get a Free Quote',

  // CTA Section
  cta_badge: 'Ready to Get Started?',
  cta_heading: 'Get Your',
  cta_heading_accent: 'Free',
  cta_heading_end: 'Quote Today',
  cta_desc: 'No commitments. We send you a personalized quote in less than 24 hours. Service available in The Villages, FL and surrounding areas.',
  cta_btn: 'Request Free Quote',
  cta_trust1: 'Insured Staff',
  cta_trust2: 'Satisfaction Guaranteed',
  cta_trust3: 'Verified Company',
  cta_trust4: 'Eco-Friendly Products',

  // Footer
  ft_desc: 'We transform spaces with professional quality cleaning. Your satisfaction is our priority.',
  ft_services: 'Services',
  ft_svc1: 'Move-Out Cleaning',
  ft_svc2: 'Window Cleaning',
  ft_svc3: 'Pressure Washing',
  ft_svc4: 'Valet Trash',
  ft_company: 'Company',
  ft_c1: 'About Us',
  ft_c2: 'Reviews',
  ft_c3: 'Services',
  ft_contact: 'Contact',
  ft_hours: 'Mon–Sat: 8am – 6pm',
  ft_copyright: 'All rights reserved.',
  ft_tagline: 'Professional residential cleaning service in The Villages, FL',

  // Services Page
  svcp_badge: 'What We Offer',
  svcp_title: 'Our Services',
  svcp_desc: 'Professional cleaning solutions for residences and condominium communities in The Villages, FL and surrounding areas.',
  svcp_quote_btn: 'Quote This Service',
  svcp_why: 'Why Choose Us?',
  svcp_w1_t: 'Certified Team',
  svcp_w1_d: 'Trained and verified staff.',
  svcp_w2_t: 'Safe Products',
  svcp_w2_d: 'Eco-friendly and non-toxic.',
  svcp_w3_t: 'Personalized Attention',
  svcp_w3_d: 'Quotes tailored to your needs.',
  svcp_w4_t: 'Transparent Pricing',
  svcp_w4_d: 'No hidden costs, fair price.',
  svcp_cta_t: 'Ready to schedule your service?',
  svcp_cta_d: 'Guaranteed response in less than 24 hours.',
  svcp_cta_btn: 'Get a Quote',

  // About Page
  abp_badge: 'Our Story',
  abp_title: 'About Us',
  abp_desc: 'We are a family business committed to transforming every space into a spotless place, with passion and professionalism.',
  abp_ess: 'Our Essence',
  abp_h2: 'Cleaning is Our Art,',
  abp_h2_accent: 'Your Satisfaction',
  abp_h2_end: 'Our Goal',
  abp_p1: 'We were born from the conviction that a clean home is a happy home. Every space we touch receives the same care and attention we would give our own home.',
  abp_p2: 'We combine advanced techniques, high-quality products, and a passionate team to deliver results that exceed expectations. From move-out cleaning to valet trash for condominiums.',
  abp_mission_t: 'Mission',
  abp_mission_d: 'To provide exceptional cleaning services that improve the quality of life for our clients.',
  abp_vision_t: 'Vision',
  abp_vision_d: 'To be the most recognized and trusted cleaning company in The Villages, FL and surrounding areas.',
  abp_stat1: 'Total Guarantee',
  abp_stat2: 'Free Quote',
  abp_timeline_tag: 'Our Story',
  abp_timeline_h: 'Beginning to Grow With You',
  abp_team_tag: 'The People Behind It',
  abp_team_h: 'Our Team',
  abp_val_h: 'Our Values',
  abp_v1_t: 'Integrity',
  abp_v1_d: 'Honesty and transparency in every interaction.',
  abp_v2_t: 'Excellence',
  abp_v2_d: "We don't stop until it's perfect.",
  abp_v3_t: 'Respect',
  abp_v3_d: 'Your home and privacy are sacred to us.',
  abp_v4_t: 'Responsibility',
  abp_v4_d: 'We care for the environment in our processes.',
  abp_cta_t: 'Work with a Team You Can Trust',
  abp_cta_d: 'Take the first step with a company that puts your satisfaction first. Professional service in The Villages, FL.',
  abp_cta_btn: 'Request Free Quote',
  abp_m1_t: 'A Dream Was Born',
  abp_m1_d: 'With a passion for transforming homes, we made the decision to start our business in The Villages, FL.',
  abp_m2_t: 'Official Launch',
  abp_m2_d: 'We opened our doors and began offering our services to the local community.',
  abp_m3_t: 'Seeking Our First Client',
  abp_m3_d: 'We are ready to prove our professionalism. Be the first to trust us!',
  abp_m4_t: 'Our Goal for 2026',
  abp_m4_d: 'To become the #1 trusted cleaning company throughout The Villages, FL area.',
  abp_tr1: 'Founder & Director',
  abp_tb1: 'With over 10 years in the cleaning industry, Rosa founded the company with the vision of offering a service that combined exceptional quality with a family touch.',
  abp_tr2: 'Operations Supervisor',
  abp_tb2: 'Carlos coordinates all field teams to ensure every job meets our quality and punctuality standards.',
  abp_tr3: 'Window Cleaning Specialist',
  abp_tb3: 'Lucía leads our residential and commercial window cleaning team, with extensive expertise in streak-free techniques and delicate surface handling.',

  // Reviews Page
  revp_badge: 'Reviews',
  revp_title: 'Client Reviews',
  revp_desc: "We're beginning to write our story. Be among the first to experience our service and share your feedback.",
  revp_avg: 'Average Rating',
  revp_based: 'Based on {{count}} reviews',
  revp_all: 'All',
  revp_cta_t: 'Be Our First Client!',
  revp_cta_d: 'We start with the commitment to exceed your expectations. Request your quote and be part of our story in The Villages, FL.',
  revp_cta_btn: 'Request Free Quote',
  revp_empty: 'No reviews for this filter.',
  revp_empty_h: 'No Reviews Yet!',
  revp_empty_d: "We're a new business eager to earn your trust. Be the first to try our service and tell us about your experience.",
  sf_all: 'All',
  sf_move_out: 'Move-Out Cleaning',
  sf_new_construction: 'New Construction',
  sf_windows: 'Window Cleaning',
  sf_pressure: 'Pressure Washing',
  sf_valet: 'Valet Trash - Condo',

  // Quote Modal
  qm_title: 'Request a Quote',
  qm_sub: 'Response in less than 24 hours',
  qm_name: 'Name',
  qm_name_ph: 'Your name',
  qm_phone: 'Phone',
  qm_phone_ph: '(305) 000-0000',
  qm_email_label: 'Email Address',
  qm_email_ph: 'your@email.com',
  qm_service: 'Service of Interest',
  qm_service_ph: 'Select a service',
  qm_svc1: 'Move-Out Cleaning',
  qm_svc2: 'Window Cleaning',
  qm_svc3: 'Pressure Washing',
  qm_svc4: 'Valet Trash Pick-Up',
  qm_svc5: 'Multiple Services',
  qm_address: 'Address / City',
  qm_address_ph: 'City or approximate address',
  qm_details: 'Additional details',
  qm_details_ph: 'Tell us more about your property or specific needs...',
  qm_btn: 'Send Quote Request',
  qm_loading: 'Sending...',
  qm_success_t: 'Request Sent!',
  qm_success_d: 'We will contact you within 24 hours with your personalized quote.',
  qm_close: 'Close',

  // Floating button
  fb_text: 'Free Quote',
};

export default translation;
